import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { setDataToLocalStorage } from 'src/localStorage/setDataToLocalStorage';

interface UserData {
  role?: string;
  sessionId?: string;
}

export const setUserDataToLocalStorage = ({ sessionId, role }: UserData) => {
  if (sessionId) {
    setDataToLocalStorage(LocalStorageKey.SESSION_ID, sessionId);
  }

  if (role) {
    setDataToLocalStorage(LocalStorageKey.USER_ROLE, role);
  }
};
